<script>
import options from './OverlayMenu.options'
const componentOptions = options
export default componentOptions
</script>

<template>
  <nav class="be-overlay__menu be-js--overlay-container" :class="{ 'be-overlay__menu--hide' : isActiveLevel }">

    <div class="be-menu-primary__nav" :aria-label="getLabel('menuNavAriaLabel')">

      <a class="be-menu-primary__logo-link be-js--mobile-menu-item" href="/" aria-label="Better Energy" v-on:keydown="tabTrap">
        <div class="be-menu-primary__logo-icon be-menu-primary__logo-icon--mobile">
          <svg role="presentation" viewBox="0 0 62 56" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M61.558 21.974c-.873-7.713-7.42-13.707-15.366-13.707a15.416 15.416 0 0 0-10.945 4.54 15.409 15.409 0 0 0-4.417 9.147c-.882-7.703-7.423-13.687-15.363-13.687-2.388 0-4.648.541-6.667 1.507l-.022.01a.717.717 0 0 1-.993-.662V6.968A6.469 6.469 0 0 0 1.317.5H.735a.718.718 0 0 0-.718.716v21.8a16.249 16.249 0 0 0 0 1.43c.248 5.445 3.31 10.155 7.766 12.711a15.385 15.385 0 0 0 7.682 2.04c7.939 0 14.479-5.982 15.364-13.683.086.75.225 1.483.415 2.195 1.755 6.614 7.782 11.488 14.948 11.488 3.983 0 7.613-1.506 10.354-3.979.004-.004.01-.007.013-.011a.715.715 0 0 0 .05-1.039l-.021-.02-4.484-4.484-.011-.012a.713.713 0 0 0-.954-.042l-.007.005a7.651 7.651 0 0 1-4.939 1.8 7.659 7.659 0 0 1-5.686-2.52.717.717 0 0 1 .541-1.183h19.533c.326 0 .601-.22.688-.518l.018-.083a15.493 15.493 0 0 0 .271-5.136Zm-46.093 9.44a7.682 7.682 0 1 1 .001-15.364 7.682 7.682 0 0 1 0 15.365Zm37.24-9.439H39.68a.717.717 0 0 1-.658-1 7.66 7.66 0 0 1 1.73-2.661 7.683 7.683 0 0 1 12.64 2.743.717.717 0 0 1-.686.92l-.002-.002ZM2.609 52.717c-.357 0-.868-.072-1.224-.19l-1.343.201v-8.115l1.401-.19v3.172c.368-.356.868-.7 1.534-.7 1.45 0 2.4 1.175 2.4 2.862s-1.213 2.958-2.768 2.958v.002Zm-.036-4.646c-.463 0-.82.18-1.128.452v2.767c.26.203.617.31 1.033.31.938 0 1.473-.761 1.473-1.783 0-1.022-.511-1.746-1.378-1.746ZM7.279 50.115c.06.891.665 1.496 1.639 1.496.582 0 1.212-.19 1.71-.498l.18 1.164c-.524.286-1.248.451-1.986.451-1.759 0-2.923-1.117-2.923-2.862 0-1.746 1.19-2.97 2.828-2.97 1.45 0 2.258.88 2.258 2.222 0 .297-.047.677-.12.915l-3.588.047v.035h.002Zm2.388-.868v-.095c0-.737-.321-1.2-1.046-1.2-.772 0-1.235.63-1.307 1.307l2.353-.012ZM13.788 52.728c-1.224 0-1.864-.535-1.818-1.852l.084-2.579-.856-.095.035-.891.856-.273.024-1.212h1.354l-.023 1.282h1.545l-.036 1.153h-1.591l-.072 2.53c-.012.51.249.749.724.749.286 0 .57-.072.856-.166l.19 1.14a3.718 3.718 0 0 1-1.27.214h-.002ZM17.745 52.728c-1.224 0-1.865-.535-1.818-1.852l.084-2.579-.856-.095.035-.891.856-.273.023-1.212h1.355l-.024 1.282h1.545l-.035 1.153h-1.592l-.072 2.53c-.011.51.25.749.725.749.285 0 .57-.072.855-.166l.191 1.14a3.719 3.719 0 0 1-1.27.214h-.002ZM20.763 50.115c.06.891.665 1.496 1.639 1.496.582 0 1.212-.19 1.71-.498l.18 1.164c-.524.286-1.248.451-1.986.451-1.759 0-2.922-1.117-2.922-2.862 0-1.746 1.188-2.97 2.827-2.97 1.45 0 2.258.88 2.258 2.222 0 .297-.047.677-.12.915l-3.587.047v.035Zm2.388-.868v-.095c0-.737-.321-1.2-1.046-1.2-.772 0-1.235.63-1.307 1.307l2.353-.012ZM26.74 52.55h-1.402v-5.442l1.401-.202v.891c.345-.582.785-.903 1.427-.903.332 0 .677.072.974.25l-.309 1.259a1.63 1.63 0 0 0-.784-.214c-.487 0-.938.31-1.308.975v3.386ZM32.597 49.913c.023 1.224.76 2.103 1.9 2.103.595 0 1.165-.179 1.581-.451l.142.677c-.463.286-1.068.463-1.746.463-1.568 0-2.625-1.176-2.625-2.828s1.094-2.922 2.567-2.922c1.2 0 1.984.784 1.984 2.008 0 .285-.047.63-.118.867l-3.684.024v.06l-.001-.001Zm3.065-.654c.011-.059.012-.179.012-.238 0-.83-.452-1.401-1.308-1.401-.975 0-1.604.749-1.722 1.652l3.018-.012v-.001ZM41.04 52.55v-3.517c0-.95-.38-1.378-1.2-1.378-.594 0-1.2.321-1.652.773v4.122h-.736v-5.442l.736-.153v.89c.57-.57 1.283-.89 1.853-.89 1.094 0 1.734.677 1.734 1.864v3.73h-.736.002ZM43.45 49.913c.024 1.224.761 2.103 1.902 2.103.593 0 1.164-.179 1.58-.451l.142.677c-.463.286-1.069.463-1.746.463-1.568 0-2.625-1.176-2.625-2.828s1.093-2.922 2.566-2.922c1.2 0 1.985.784 1.985 2.008 0 .285-.047.63-.119.867l-3.683.024v.06l-.002-.001Zm3.066-.654c.011-.059.011-.179.011-.238 0-.83-.451-1.401-1.307-1.401-.975 0-1.604.749-1.723 1.652l3.019-.012v-.001ZM49.024 52.55h-.736v-5.442l.736-.153v1.163c.356-.7.89-1.163 1.603-1.163.357 0 .701.107.95.249l-.19.689a1.623 1.623 0 0 0-.831-.238c-.57 0-1.106.428-1.534 1.402v3.493h.002ZM51.663 51.695c0-.452.392-.843.892-1.033-.524-.321-.88-.915-.88-1.664 0-1.152.856-2.043 2.139-2.043.57 0 .986.153 1.282.32l1.509-.118.035.737-1.2-.119c.26.261.44.784.44 1.224 0 1.152-.904 1.997-2.116 1.997-.297 0-.535-.06-.808-.154-.285.118-.605.344-.605.653 0 .345.261.559 1.236.559h.7c1.58 0 2.258.535 2.258 1.426 0 1.2-1.343 2.02-2.863 2.02s-2.46-.642-2.46-1.592c0-.617.475-1.164 1.176-1.343-.463-.165-.737-.475-.737-.867l.002-.003Zm.273 2.079c0 .642.7 1.117 1.853 1.117 1.152 0 2.043-.547 2.043-1.283 0-.642-.57-.868-1.651-.868-.368 0-.832-.012-1.141-.035-.654.179-1.105.605-1.105 1.069h.001Zm1.865-3.375c.831 0 1.354-.593 1.354-1.426 0-.832-.475-1.413-1.39-1.413-.842 0-1.366.605-1.366 1.45 0 .784.524 1.39 1.402 1.39Z"
              fill="#1E2B24" />
            <path
              d="m59.578 52.491-.44 1.176c-.499 1.33-1.022 1.71-1.76 1.71-.415 0-.723-.107-1.056-.249l.226-.677c.26.142.535.237.83.237.417 0 .725-.225 1.118-1.259l.368-.963-2.127-5.358h.796l1.71 4.492 1.676-4.492h.773l-2.116 5.383h.002Z"
              fill="#1E2B24" />
          </svg>
        </div>
      </a>

    </div>

    <div class="be-menu-primary__actions" :aria-label="getLabel('menuActionsAriaLabel')">

      <ul class="be-menu-primary__menu-list be-menu-primary__menu-list--mobile">
        <template v-if="menuActionsDisplayNames['login-button']?.href">
          <li class="be-menu-primary__menu-list-item">
              <a :href="menuActionsDisplayNames['login-button'].href" class="be-menu-primary__actions-item be-js--mobile-menu-item" v-on:keydown="tabTrap">
                  <div class="be-icon">
                      <svg role="presentation" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path
                              d="M19 11H5a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2ZM7 11V7a5 5 0 1 1 10 0v4"
                              stroke="#1E2B24"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                          /></svg>
                  </div>
                  <span class="be-menu-primary__actions-item-text be-visually-hidden">
                      {{ menuActionsDisplayNames['login-button'].name }}
                  </span>
              </a>
          </li>
        </template>
        <li class="be-menu-primary__menu-list-item">
          <button 
              v-on:click="handleMenuItem('changeRegion')"  
              v-on:keydown="tabTrap"
              :aria-expanded="isActiveLevel"
              aria-haspopup="true"
              class="be-menu-primary__actions-item be-js--mobile-menu-item be-js--mobile-region-overlay-button">
              <div class="be-icon">
                  <svg role="presentation" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path
                          d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10ZM2 12h20"
                          stroke="#1E2B24"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                      /><path
                          d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10v0Z"
                          stroke="#1E2B24"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                      /></svg>
              </div>
              <span class="be-menu-primary__actions-item-text be-visually-hidden">
                {{ menuActionsDisplayNames['region-button'].name }}
              </span>
          </button>
        </li>
        <li class="be-menu-primary__menu-list-item be-menu-primary__menu-list-item--burger">
            <button v-on:click="closeTheModal" :aria-label="getLabel('closeMenu')" class="be-js--mobile-menu-item" v-on:keydown="tabTrap">
                <div class="be-icon">
                    <svg role="presentation" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><g stroke="#1E2B24" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" clip-path="url(#a)"><path d="M18 6 6 18M6 6l12 12"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h24v24H0z"/></clipPath></defs></svg>
                </div>
            </button>
        </li>
      </ul>

     </div>

  </nav>

  <div class="be-overlay__content">

    <nav class="be-region-overlay-mobile" :class="{ 'be-region-overlay-mobile--hide' : !isActiveLevel }">
      <div class="be-region-overlay-mobile__header">
        <button v-on:click="closeMenu" :aria-label="getLabel('closeMenu')" v-on:keydown="tabTrap" class="be-icon be-js--mobile-menu-item">
          <svg role="presentation" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path stroke="#11583A" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m15.5 19-7-7 7-7"/></svg>
        </button>
      </div>

      <template v-for="group, index in regionMenuMobileData" :key="index">
        <section class="be-region-overlay-mobile__content">
          <p class="be-region-overlay-mobile__content-title">{{ group.displayName }}</p>
          <ul class="be-region-overlay-mobile__content-list" :aria-label="group.displayName">
            <li v-for="link, linkIndex in group.links" :key="linkIndex">
              <a  
                v-on:keydown="tabTrap"
                :href="link.href"
                class="be-region-overlay-mobile__content-list-link be-js--mobile-menu-item" 
                :class="{ 'be-region-overlay-mobile__content-list-link--active' : link.active }"
              >
                <div>
                  <span class="be-region-overlay-mobile__content-list-icon" v-if="link.icon" v-html="link.icon"></span>
                  <p class="be-visually-hidden" v-if="link.iconAriaLabel">{{ link.iconAriaLabel }}</p>
                </div>
                <span>{{ link.displayName }}</span>
              </a>
            </li>
          </ul>
        </section>
      </template>
    </nav>
  
    <div :class="{ 'be-overlay__content--hide' : isActiveLevel }">
      <a :href="menuActionsDisplayNames['search-button'].href" v-on:keydown="tabTrap" class="be-btn be-btn--outline be-btn--mobile-search be-js-cta-button be-js--mobile-menu-item">{{ menuActionsDisplayNames['search-button'].name }}</a>

        <ul class="be-accordion-group__list">

          <template v-for="(group,index) in primaryMenuMobileData" :key="index">
            <li class="be-accordion-group__list-item">
                <details class="be-accordion be-overlay__menu__accordion">
                    <summary class="be-accordion__header be-overlay__menu__summary be-js--mobile-menu-item" v-on:keydown="tabTrap">
                        <p class="be-accordion__header-title be-overlay__menu__group-name">{{ group.displayName }}</p>
                        <span class="be-accordion__header-arrow">
                            <svg role="presentation" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path
                                    stroke="#130F26"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="1.5"
                                    d="m5 15.5 7-7 7 7"
                                /></svg>
                        </span>
                    </summary>
                    <article class="be-accordion__content">

                      <template v-for="(link, linkindex) in group.links" :key="linkindex">
                        <a v-on:keydown="tabTrap" class="be-overlay__menu__link be-overlay__menu__link--primary be-js--mobile-menu-item" :class="menuLinkType(link)" :href="link.href">
                          {{ link.displayName }}
                          <template v-if="link.toplevel">
                            <div class="be-icon">
                              <svg role="presentation" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="M12 21.25a9.25 9.25 0 1 0 0-18.5 9.25 9.25 0 0 0 0 18.5Z" stroke="#1E2B24" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M10.558 15.47 14.044 12l-3.486-3.471" stroke="#1E2B24" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                            </div>
                          </template>
                        </a>
                      </template>

                    </article>
                </details>
            </li>
          </template>

          <template v-if="ctaButtonData">
            <a :href="ctaButtonData.href" v-on:keydown="tabTrap" class="be-btn be-btn--outline be-btn--cta be-js-cta-button be-js--mobile-menu-item">{{ ctaButtonData.displayName }}</a>
          </template>

          
          <template v-for="(group,index) in secondaryMenuMobileData" :key="index">
            <li class="be-accordion-group__list-item">

              <template v-if="group.href">
                <a v-on:keydown="tabTrap" class="be-overlay__menu__link be-overlay__menu__link--secondary be-js--mobile-menu-item" :href="group.href">{{ group.displayName }}</a>
              </template>

              <template v-else>
                <details class="be-accordion">
                    <summary v-on:keydown="tabTrap" class="be-accordion__header be-overlay__menu__summary be-overlay__menu__summary--secondary be-js--mobile-menu-item">
                        <p class="be-accordion__header-title be-overlay__menu__group-name be-overlay__menu__link--secondary">{{ group.displayName }}</p>
                        <span class="be-accordion__header-arrow">
                            <svg role="presentation" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path
                                    stroke="#130F26"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="1.5"
                                    d="m5 15.5 7-7 7 7"
                                /></svg>
                        </span>
                    </summary>
                    <article class="be-accordion__content be-overlay__menu__content">

                      <template v-for="(link, linkindex) in group.subItems" :key="linkindex">
                        <a v-on:keydown="tabTrap" class="be-overlay__menu__link be-js--mobile-menu-item" :href="link.href">{{ link.displayName }}</a>
                      </template>

                    </article>
                </details>
              </template>
            
            </li>
          </template>

        </ul>
    </div>

  </div>
</template>